/**
 * WordPress URL Detector (stub - not applicable for this site)
 */

const WP_PATTERNS = [
  /^\/wp-content\//,
  /^\/wp-includes\//,
  /^\/wp-admin\//,
  /^\/wp-login/,
  /\?p=\d+/,
  /\?page_id=\d+/,
];

export const isWordPressUrl = (path) => {
  if (!path) return false;
  return WP_PATTERNS.some((pattern) => pattern.test(path));
};

export const getCanonicalForWordPressUrl = (path, baseUrl) => {
  return baseUrl || '/';
};
